'use strict';
import React, { Component } from 'react'
var FormatMessage = require('react-globalize').FormatMessage;
import FraudAlerts from './fraudAwareContent/fraudAlerts';
import FraudTypes from './fraudAwareContent/fraudTypes';
import HowProtect from './fraudAwareContent/howProtect';
import Knowledge from './fraudAwareContent/knowledge';
import News from './fraudAwareContent/news';

// var ESignEN = require('../public/documents/e-signEN.js');
// var ESignES = require('../public/documents/e-signES.js');



export default class sectionPromotionUpdated extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    var message = "";
    console.log("locale", this.props.locale)
    return (

      <div className="container" id="terms-cond-div" style={{ "marginTop": "5%", "marginBottom": "5%" }}>
        <div className="row" style={{ "marginTop": "3%", "marginBottom": "2%" }}>

          <h3 className="text-center">
            <FormatMessage locale={this.props.locale} path="footer/fraudAware" />
          </h3>

          <hr className="small-blue" />
        </div>

        <ul className="nav nav-tabs nav-fill nav-justified " id="myTab" role="tablist" style={{fontSize:"small"}}>
          <li className="nav-item active">
            <a className="nav-link active" id="fraudAlerts-tab" data-toggle="tab" href="#fraudAlerts" role="tab" aria-controls="fraudAlerts" aria-selected="true">
              <FormatMessage locale={this.props.locale} path="fraudAware/fraudAlerts" />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="fraudTypes-tab" data-toggle="tab" href="#fraudTypes" role="tab" aria-controls="fraudTypes" aria-selected="false">
            <FormatMessage locale={this.props.locale} path="fraudAware/fraudTypes" />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="howProtect-tab" data-toggle="tab" href="#howProtect" role="tab" aria-controls="howProtect" aria-selected="false">
            <FormatMessage locale={this.props.locale} path="fraudAware/howProtect" />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="knowledge-tab" data-toggle="tab" href="#knowledge" role="tab" aria-controls="knowledge" aria-selected="false">
            <FormatMessage locale={this.props.locale} path="fraudAware/knowledge" />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="whatIsNew-tab" data-toggle="tab" href="#whatIsNew" role="tab" aria-controls="whatIsNew" aria-selected="false">
            <FormatMessage locale={this.props.locale} path="fraudAware/whatIsNew" />
            </a>
          </li>
        </ul>

        <div className="tab-content" id="myTabContent">
          <div className="tab-pane active" id="fraudAlerts" role="tabpanel" aria-labelledby="fraudAlerts-tab">
            <FraudAlerts locale={this.props.locale} />
          </div>
          <div className="tab-pane fade " id="fraudTypes" role="tabpanel" aria-labelledby="fraudTypes-tab">
            <FraudTypes locale={this.props.locale} />
          </div>
          <div className="tab-pane fade" id="howProtect" role="tabpanel" aria-labelledby="howProtect-tab">
            <HowProtect locale={this.props.locale}/>
          </div>
          <div className="tab-pane fade" id="knowledge" role="tabpanel" aria-labelledby="knowledge-tab">
            <Knowledge locale={this.props.locale} />
          </div>
          <div className="tab-pane fade" id="whatIsNew" role="tabpanel" aria-labelledby="whatIsNew-tab">
            <News locale={this.props.locale} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./js/FraudAware.js